export default function BroadcastStatus({ request }) {
  if (!request) return null;

  const wave = request.broadcast_wave || 0;
  const radius = request.search_radius_km;
  const notified = request.notified_provider_count
    ?? (request.notified_provider_ids?.length ?? 0);

  return (
    <div className="resqly-card p-4 space-y-2" data-testid="broadcast-status">
      <div className="text-sm font-semibold text-slate-900 capitalize">
        {request.status?.replace(/_/g, ' ')}
      </div>
      {request.status_message && (
        <p className="text-sm text-slate-600">{request.status_message}</p>
      )}
      <div className="flex flex-wrap gap-2 text-xs text-slate-500">
        {wave > 0 && (
          <span className="bg-slate-100 px-2 py-0.5 rounded-full">Wave {wave}</span>
        )}
        {radius > 0 && (
          <span className="bg-slate-100 px-2 py-0.5 rounded-full">{radius} km</span>
        )}
        <span className="bg-slate-100 px-2 py-0.5 rounded-full">
          {notified} notified
        </span>
        {request.broadcast_active && (
          <span className="bg-blue-50 text-blue-700 px-2 py-0.5 rounded-full">Live</span>
        )}
      </div>
    </div>
  );
}
